module.exports = __webpack_public_path__ + "img/faceBind.69963f48.png";